<template>
    
    <fieldset class="date-time-edit">
        <legend>{{ label }}</legend>
        <div style="display: flex; flex-flow: row nowrap;">
            <div>
                <label :for="`field-date-${ id }`">Dato</label>
                <input 
                    required 
                    :id="`field-date-${ id }`" 
                    type="date" 
                    v-model="date" 
                    placeholder="ÅÅÅÅ-MM-DD" 
                    @change="emitChange()">
            </div>
            <div style="margin-left: 1rem;">
                <label :for="`field-time-${ id }`">Tid</label>
                <select
                    :id="`field-time-${ id }`"
                    v-model="hour"
                    @change="emitChange()"
                    class="time-input">
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                </select>
                :
                <select
                    v-model="min"
                    @change="emitChange()"
                    class="time-input">
                    <option value="0">00</option>
                    <option value="30">30</option>
                </select>
            </div>
        </div>
    </fieldset>
    
</template>

<script>

    import { dateDjango2js, leadZero, dateJs2django } from '../../utils/Filters.js'
    
    export default {
        props: [
            'datetime',
            'label'
        ],
        data: function() {
            return {
                id: null,
                datetime_out: this.datetime,
                date: null,
                hour: null,
                min: null
            }
        },
        watch: {
            datetime: function() {
                this.update()
            }
        },
        methods: {
            update: function() {
                this.datetime_out = this.datetime
                this.date = this.enParseDate(this.datetime)
                this.hour = this.enParseHour(this.datetime)
                this.min = this.enParseMin(this.datetime)
            },
            enParseDate: function(date) {
                let js_date = dateDjango2js(date)
                return `${ js_date.getFullYear() }-${ leadZero(js_date.getMonth() + 1) }-${ leadZero(js_date.getDate()) }`
            },
            enParseHour: function(date) {
                let js_date = dateDjango2js(date)
                return js_date.getHours()
            },
            enParseMin: function(date) {
                let js_date = dateDjango2js(date)
                return js_date.getMinutes()
            },
            emitChange: function() {
                const date = this.date.split('-')
                this.datetime_out = new Date(date[0], date[1] - 1, date[2], this.hour, this.min)
                this.$emit('change', dateJs2django(this.datetime_out))
            }
        },
        created: function() {
            this.update()
        },
        mounted: function() {
            this.id = this._uid
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .date-time-edit {

        .time-input {
            width: 4rem;
        }
    }

</style>
